import { render, staticRenderFns } from "./PropertyViewSubNav.vue?vue&type=template&id=345a9c6c&scoped=true"
import script from "./PropertyViewSubNav.vue?vue&type=script&lang=js"
export * from "./PropertyViewSubNav.vue?vue&type=script&lang=js"
import style0 from "./PropertyViewSubNav.vue?vue&type=style&index=0&id=345a9c6c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a9c6c",
  null
  
)

export default component.exports